<template>
  <div class="logo" :class="{'logo-audience': $store.state.logo}">
    <div class="logo-wrapper" v-if="canShowCustomLogo()">
      <img :src="$store.state.logo.large" alt>
    </div>
    <div
      class="logo-wrapper"
      :class="{'dark-theme': $store.state.isDarkTheme}"
      v-if="canShowAhaSlideLogo()"
    >
      <aha-logo
        :icon-only="false"
        :useDefaultColor="true"
        class="default-logo ahaslides-logo"
      />
      <aha-logo
        :icon-only="false"
        :useDefaultColor="false"
        class="white-logo ahaslides-logo"
      />
    </div>
  </div>
</template>
<script>
import Util from '@/util'
import { mapGetters } from 'vuex'

export default {
  props: ['homepage'],
  computed: {
    ...mapGetters({
      slideActive: 'activeActivity',
    }),
    isTextColourLight() {
      return this.slideActive.textColour === '#ffffff'
    },

  },
  methods: {
    canShowAhaSlideLogo() {
      // If using whitelabel account, dont show AhaSlides logo
      if (Util.checkWhiteLabelDomain() || this.$store.state.presentation.planType === 'white-label') return false

      return this.homepage || (!this.$store.state.logo && !this.$store.state.presentation.notShowAhaSlidesLogo && !this.homepage)
    },
    canShowCustomLogo() {
      if (this.$store.state.presentation.notShowAhaSlidesLogo) {
        return false
      }
      return !this.canShowAhaSlideLogo() && this.$store.state.logo !== null
    },
  },
}
</script>

<style lang="scss" >
.dark-theme {
  .ahaslides-logo {
    color: white !important;
  }
}

.logo {
  padding: 20px 10px;
  margin: 0 auto;
  img, .ahaslides-logo {
    max-width: 140px;
    max-height: 48px;
    width: auto;
    height: auto;
    display: block;
    margin: 0 auto;

    &.white-logo {
      display: none;
    }
  }
}

</style>
